import React, { useEffect, useState } from "react";

import { assetService } from "../../services/assetService";

interface CallAssignedToTytoModalProps {
  locale: "th" | "en";
  onClose: () => void;
}

const CallAssignedToTytoModal: React.FC<CallAssignedToTytoModalProps> = ({
  locale,
  onClose,
}) => {
  const [title, setTitle] = useState("");
  const [bodyHeader, setBodyHeader] = useState("");
  const [bodyContent, setBodyContent] = useState("");
  const [dismissLabel, setDismissLabel] = useState("");
  const [tytoCareLogo, setTytoCareLogo] = useState<string>("");

  useEffect(() => {
    const logo = assetService.getTytoCareLogo();
    setTytoCareLogo(logo);

    if (locale === "th") {
      setTitle("การแจ้งเตือน");
      setBodyHeader(
        `<img src="${logo}" alt="TytoCare Logo" style="width: 100%;">`
      );
      setBodyContent(
        `<p>ระบบกำลังส่ง SMS การใช้งานเครื่อง TytoCare ของท่าน โปรดรอสักครู่</p>`
      );
      setDismissLabel("ปิด");
    } else {
      setTitle("Notification");
      setBodyHeader(
        `<img src="${logo}" alt="TytoCare Logo" style="width: 100%;">`
      );
      setBodyContent(
        `<p>We are sending you SMS with instructions to use your TytoCare device. Please wait.</p>`
      );
      setDismissLabel("Close");
    }
  }, [locale]);

  return (
    <div
      id="modal"
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50"
    >
      <div className="bg-white max-w-3xl w-[90vw] max-h-[80vh] rounded-lg overflow-y-auto shadow-lg">
        {/* Header */}
        <div className="border-b px-6 py-4">
          <h4 id="modalHeader" className="text-lg font-semibold">
            {title}
          </h4>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <div
            id="modalBodyHeader"
            className="text-center"
            dangerouslySetInnerHTML={{ __html: bodyHeader }}
          />
          <div
            id="modalBodyContent"
            className="text-gray-700 text-center"
            dangerouslySetInnerHTML={{ __html: bodyContent }}
          />
        </div>

        {/* Footer */}
        <div className="border-t flex justify-end px-6 py-4">
          <button
            id="modalDismissButton"
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-gray-200 text-gray-800 hover:bg-gray-300"
          >
            {dismissLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CallAssignedToTytoModal;
